module.exports = __webpack_public_path__ + "media/src/img/uni/visa-8d67aa6246545b4434d879fbe9e79323.svg";